export const selectors = {
    backInStock: {
        button: '[data-micromodal-trigger="back-in-stock"]',
        form: '[data-back-in-stock-form]',
        product: '[data-back-in-stock-product]',
        variant: '[data-back-in-stock-variant]',
    },
    color: '[data-product-color]',
    compareAtPrice: '[data-compare-at-price]',
    form: {
        id: '[name="id"]',
    },
    images: {
        list: '[data-product-images-list]',
        template: '[data-product-image-template]',
        wrapper: '[data-product-images]',
        videoTemplate: '[data-product-video-item]',
    },
    description: {
        header: '[data-description-header]',
        body: '[data-description-body]',
        action: '[data-description-action]',
    },
    giftCard: {
        message: '[data-gift-card-message]',
        recipientEmail: '[data-gift-card-recipient-email]',
        recipientName: '[data-gift-card-recipient-name]',
        recipientSendOn: '[data-gift-card-recipient-send-on]',
    },
    option: '[data-product-option]',
    price: '[data-price]',
    priceWrapper: '[data-price-wrapper]',
    productActionsWrapper: '[data-product-actions-wrapper]',
    productAction: '[data-product-action]',
    productActionFixed: '[data-product-action-fixed]',
    productForm: '[data-product-form]',
    productQuantity: '[data-product-quantity]',
    recommendedProductSlider: '[data-product-slider]',
    size: '[data-product-size]',
    sku: '[data-product-sku]',
    skuWrapper: '[data-product-sku-wrapper]',
    barcode: '[data-product-barcode]',
    barcodeWrapper: '[data-product-barcode-wrapper]',
    screenReader: {
        addedToCart: '[data-cart-screen-reader-message]',
        addedToWishlist: '[data-wishlist-screen-reader-message]',
    },
    submitButton: '[data-add-to-cart]',
    wishListButton: '[data-toggle-wishlist]',
    retailPrice: '[data-retail-price]',
    variant: option => `[data-product-variant="${option}"]`,
    sizeAltSnippet: '[data-product-size-alt]'
};

export const getCurrentOptions = () => {
    const form = document.querySelector(selectors.productForm);

    return Array.from(form.elements)
        .map(({ name }) => {
            return name;
        })
        .filter(
            (name, index, self) =>
                name.includes('options[') && self.indexOf(name) === index
        )
        .map(name => {
            return {
                name,
                value: form.elements[name].value,
            };
        });
};

export const getColourOption = () => {
    const colourOption = getCurrentOptions().filter(({ name }) =>
        name.toLowerCase().includes('colour')
    );

    if (colourOption.length > 0) {
        return colourOption[0].value;
    }
};

export const getOptionAfterColour = () => {
    const options = getCurrentOptions();
    const colourIndex = options.findIndex(
        value => value.name === 'options[Colour]'
    );

    if (colourIndex + 1 >= options.length) {
        return options.filter(({ name }) =>
            name.toLowerCase().includes('colour')
        )[0];
    }

    return options[colourIndex + 1];
};

export const getSizeOption = () => {
    return getCurrentOptions().filter(({ name }) =>
        name.toLowerCase().includes('size')
    )[0];
};

export const getCurrentVariant = () => {
};
